export default __webpack_public_path__ + "locales/vi/ChangeEmailDialog.json?hash=8e3b5e635af4e6c6f4ec7a6a751d7229";